import { motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";

const STEPS = [
  { t: "Share your idea", d: "Send a drawing, sketch, photo or sample on WhatsApp, email or the quote form." },
  { t: "Get a quotation", d: "We confirm material, size, finish and quantity, then share a clear price." },
  { t: "Cut & craft", d: "Your job is programmed, cut, machined or carved and finished in our workshop." },
  { t: "Collect or deliver", d: "We check the finished work with you and arrange pickup or delivery." },
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="relative py-24 sm:py-32 bg-[#0e1116] text-white overflow-hidden">
    <div className="absolute inset-0 opacity-[0.07] [background-image:linear-gradient(#fff_1px,transparent_1px),linear-gradient(90deg,#fff_1px,transparent_1px)] [background-size:56px_56px]" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
      <Reveal>
        <Overline className="!text-[#e8c36a]">How it works</Overline>
        <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-5 leading-[0.98] max-w-3xl">
          From sketch to finished part in <span className="text-gold-grad">four steps.</span>
        </h2>
      </Reveal>
      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/15">
        {STEPS.map((s, i) => (
          <motion.div key={s.t} data-testid={`process-step-${i + 1}`}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="group bg-[#0e1116] p-7 sm:p-9 min-h-[260px] flex flex-col justify-between hover:bg-[#151a21] transition-colors">
            <span className="font-display text-6xl font-extrabold text-transparent [-webkit-text-stroke:1px_#e8c36a] group-hover:text-[#e8c36a] transition-colors duration-500">0{i + 1}</span>
            <div>
              <h3 className="font-display text-2xl font-semibold">{s.t}</h3>
              <p className="mt-3 text-sm sm:text-base text-slate-300 leading-relaxed">{s.d}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
